























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import CouponSummary from "./couponSummary.vue";
import CouponDetail from "./couponDetail.vue";

const k2Coupon = namespace("k2Coupon");

@Component({ components: { CouponSummary, CouponDetail } })
export default class k2CouponLayout extends Vue {
  @k2Coupon.State expressFeesTabType;
  @k2Coupon.Mutation toggleExpressFeesTab;
  tagValue = "1";
  isHidden = false;
  tagList = [
    { label: "门店用券统计", name: "summary" },
    { label: "门店获券明细", name: "detail" },
  ];
  tabToggleHandle(tab, event) {
    this.toggleExpressFeesTab({ type: tab.name });
  }
  destroyed() {
    this.toggleExpressFeesTab({ type: "summary", detailMonth: "" });
  }
}
